import * as THREE from 'three'
import findMaximumPerimeter from "./findMaximumPerimeter";
import calculateHeight from "./calculateHeight";

interface updateFromProps{
    onChange: (name: string, value: any) => void;
    updateForm: (itemName: string, attributeName: string, attributeValue: any) => void;
    obj: any;
}


export default function ({onChange, updateForm, obj}:updateFromProps): void {

    const fix = (n: number) => {
        return Number(n).toFixed(1)
    }

    const uvProjection = (window as any).threeViewer?.uvProjection || 'cylindrical'
    const isPlanarOrBox = uvProjection === 'planar' || uvProjection === 'box' || uvProjection === 'none'

    let width: number
    if (isPlanarOrBox) {
        // For planar/box/none: width is the bounding box X extent (flat surface width)
        const box = new THREE.Box3().setFromObject(obj)
        const size = new THREE.Vector3()
        box.getSize(size)
        width = size.x * 1000
    } else {
        // For cylindrical: width is the circumference (maximum perimeter)
        width = findMaximumPerimeter(obj) * 1000
    }
    const height = calculateHeight(obj) * 1000;

    updateForm("width", "max", fix(width))
    updateForm("height", "max", fix(height))
    updateForm("offsetY", "max", fix(height  + obj.userData.bottomY * 1000 || 0))

    onChange("width", fix(width/ 4));
    onChange("height", fix(height/ 4));
    onChange("radialAngle", "0");
    onChange("offsetY", fix(height/2));

    updateForm("height", "max", fix(height))
    updateForm("offsetY", "max", fix(height * 2))


    onChange("targetObject", {
        name: obj.name,
        width: fix(width),
        height: fix(height),
    });

}